/**
 * StatusBadge Component
 *
 * Displays the current workflow status of a report with appropriate styling.
 */

import { useTranslation } from 'react-i18next';
import type { ReportWorkflowStatus } from '../../services/firestore';
import './StatusBadge.css';

interface StatusBadgeProps {
  status: ReportWorkflowStatus;
  size?: 'small' | 'medium' | 'large';
}

const statusConfig: Record<ReportWorkflowStatus, { labelKey: string; className: string }> = {
  draft: { labelKey: 'status.draft', className: 'status-draft' },
  pending_admin: { labelKey: 'status.pendingAdmin', className: 'status-pending-admin' },
  client_review: { labelKey: 'status.clientReview', className: 'status-client-review' },
  pending_committee: { labelKey: 'status.pendingCommittee', className: 'status-pending-committee' },
  approved: { labelKey: 'status.approved', className: 'status-approved' },
  rejected: { labelKey: 'status.rejected', className: 'status-rejected' },
};

export default function StatusBadge({ status, size = 'medium' }: StatusBadgeProps) {
  const { t } = useTranslation();
  const config = statusConfig[status];

  return (
    <span className={`status-badge ${config.className} status-${size}`}>
      {t(config.labelKey)}
    </span>
  );
}
